import { IActivityFormValue } from 'FeatureModules/Activity/schemas/activities.schema';
import { IChainActivityFormValue } from 'FeatureModules/ComponentChain/schemas/chains.schema';
import { IActivity } from 'FeatureModules/Activity/types/activity.types';
import omit from 'lodash/omit';

export const extractActivityMutationValues = (
  values?:
    | IChainActivityFormValue
    | {
        activity?: IActivityFormValue;
      }
) => ({
  ownedById: values?.activity?.ownedBy?.id || null,
  componentId: values?.activity?.component?.id || null,
  siteId: values?.activity?.site?.id || null,
  ...omit(values?.activity, [
    'id',
    'ownedBy',
    'component',
    'langs',
    'cultivatedAreas',
    'modifiedTimestamp',
    'createdTimestamp',
    'site',
    'lang',
  ]),
});

export const updateLocationActivitiesCollection = (
  currentActivities: IActivity[],
  newActivity: IActivity
): IActivity[] => {
  return [...currentActivities, newActivity];
};
